import i18n from '@/i18n'

export default [
    {
        value: i18n.t('miniCurriculum.form.label.english'),
        label: i18n.t('miniCurriculum.form.label.english'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.portuguese'),
        label: i18n.t('miniCurriculum.form.label.portuguese'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.spanish'),
        label: i18n.t('miniCurriculum.form.label.spanish'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.french'),
        label: i18n.t('miniCurriculum.form.label.french'),
    },
    {
        value: i18n.t('miniCurriculum.form.label.others'),
        label: i18n.t('miniCurriculum.form.label.others'),
    },
]
